module.exports = __webpack_public_path__ + "media/musikquiz.14dae23f.webm";